var _toArray = require("@babel/runtime/helpers/toArray");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
const fspath = require('path');
const _require = require('@truqc/content-path'),
  appendPath = _require.appendPath,
  parsePath = _require.parsePath;
const _require2 = require('./evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const getFormContent = async (uuid, content, parentContentPath, transientContext, nativeFunctions) => {
  if (uuid === content.id) {
    return content;
  }
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const name = appendPath('formCache', uuid);
  const getCacheSource = {
    type: 'getCacheValueBehavior',
    name
  };
  let formContent = await sourceEvaluator(getCacheSource);
  if (formContent === undefined || formContent === null) {
    const querySource = {
      type: 'getFormContentBehavior',
      entityName: 'Form',
      uuid
    };
    formContent = await sourceEvaluator(querySource);
    if (formContent !== undefined && formContent !== null) {
      const setCacheSource = {
        type: 'setCacheValueBehavior',
        name,
        value: formContent
      };
      await sourceEvaluator(setCacheSource);
    }
  }
  return formContent || {};
};
const valueForKey = (key, object) => {
  if (key === '?') {
    const _Object$keys = Object.keys(object),
      _Object$keys2 = _slicedToArray(_Object$keys, 1),
      actualKey = _Object$keys2[0];
    if (actualKey === undefined) {
      return undefined;
    }
    return object[actualKey];
  }
  if (key === '*') {
    return object;
  }
  return object[key];
};
const traverseFormContent = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  let formContentPath = await sourceEvaluator(source.contentPath);
  if (formContentPath === undefined) {
    return {};
  }
  let formContent = content;
  let formID = await sourceEvaluator(source.formID);
  if (formID === undefined) {
    formContentPath = appendPath(parentContentPath, formContentPath);
  } else {
    formContent = await getFormContent(formID, content, parentContentPath, transientContext, nativeFunctions);
  }
  const contentForValue = async (value, rest) => {
    if (value === undefined) {
      return undefined;
    }
    const newFormID = value._formRef;
    if (newFormID === undefined || rest.length === 0) {
      return value;
    }
    formID = newFormID;
    formContent = await getFormContent(formID, content, parentContentPath, transientContext, nativeFunctions);
    formContentPath = fspath.join(...rest);
    return formContent;
  };
  let currentContent = formContent;
  let pathComponents = parsePath(formContentPath);
  while (pathComponents.length > 0) {
    const _pathComponents = pathComponents,
      _pathComponents2 = _toArray(_pathComponents),
      first = _pathComponents2[0],
      rest = _arrayLikeToArray(_pathComponents2).slice(1);
    const value = valueForKey(first, currentContent);
    if (value === undefined) {
      return {
        formID,
        formContent,
        formContentPath
      };
    }
    // eslint-disable-next-line no-await-in-loop
    currentContent = await contentForValue(value, rest);
    pathComponents = rest;
  }
  return {
    formID,
    formContent,
    formContentPath,
    value: currentContent
  };
};
module.exports = {
  getFormContent,
  valueForKey,
  traverseFormContent
};